import React from "react";

export default function DonateSuccess() {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");

  return (
    <div style={{ maxWidth: 720, margin: "24px auto", padding: "0 16px" }}>
      <h1>Thank you! 💙</h1>
      <p>Your donation was processed successfully.</p>
      {sessionId && (
        <p style={{ color: "#777", fontSize: 12 }}>
          Stripe session: <code>{sessionId}</code>
        </p>
      )}
      <a href="/stream">Back to the stream</a>
    </div>
  );
}
